/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
// import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
// import TabletBreakpoint from "util/responsive/tablet_breakpoint";

class PartnerItem extends Component {
  rowClassName = "";

  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };

  render() {
    const { partner } = this.props;
  
    return (
      <>
        <tr className={this.rowClassName}>
          <td className="showGrup">{partner.dealerPartnerName}</td>
          <td className="showGrup">{partner.shareholdingPercent}</td>
          <td className="showGrup">
            {partner.partnershipDate && this.renderDate(partner.partnershipDate)}
          </td>
        </tr>
      </>
    );
  }
}

export default PartnerItem;
